<script lang="ts">
    import {Tooltip, Button, Select} from 'svelma';
    import SettingsModal from "./modals/SettingsModal.svelte";
    import {createEventDispatcher} from "svelte";
    import {_} from 'svelte-i18n';

    export let languages;

    const dispatch = createEventDispatcher();

    function modalOpen(event){
        dispatch('modalOpen',{
            type: 'settings',
            data: null
        });
    }

   function redirect() {window.location.href = "http://www.mik.pte.hu";}
</script>

<div class="p-2 columns is-gapless marginOff">
    <div class="column is-narrow pointer" on:click={redirect}>
        <div class="logo"></div>
    </div>
    <div class="column is-narrow has-text-white title has-text-centered-mobile">
        <div on:click={redirect} class="is-inline pointer">PTE</div>
        <div on:click={redirect} class="mik pointer">MIK</div>
        <div class="cursor is-inline has-text-centered-mobile">{$_('menubar.title')}</div>
    </div>
    <Tooltip label="Az oldal még csak Beta módban üzemel." position="is-right">
        <div class="help">beta</div>
    </Tooltip>
    <div class="column"></div>
    <div class="column is-narrow">
        <Select bind:selected={$languages} size="is-small" placeholder="Language" icon="globe" iconPack="fa" rounded>
            <option value="hu">{$_('menubar.hun')}</option>
            <option value="en">{$_('menubar.eng')}</option>
        </Select>
    </div>
</div>


<style>
    .mik{color: #0a2240; display: inline}

    .pointer{cursor: pointer;}

    .help{cursor: help}

    .cursor{cursor: default;}

    .marginOff{margin: 0!important;}

    .title{line-height: 50px}

    .logo{
        background-image: url("/assets/logo_mik.png");
        width: 50px;
        height: 50px;
        background-size: cover;
        margin: auto 10px auto 10px;
    }
</style>